import contract from "../generated/shared/types/techpack_form_contract.json";

export { contract };
export function formLabel(key: string, lang: string): string {
  const labels = contract.labels as Record<string, Record<string, string>>;
  return labels[key]?.[lang] ?? labels[key]?.en ?? key;
}
export function seasonYears(now = new Date()): string[] {
  // Rolling window aligned with SpecFlow's bind modal (_seasonYearOptions):
  // one year back (in-progress collections) through four forward.
  return Array.from({ length: contract.rolling_year_count }, (_, i) => String(now.getFullYear() - 1 + i));
}
export type SizePreset = { system: string; unit: string; category?: string; sizes: Record<string, Record<string, number>> };
export const sizePresets = contract.size_presets as unknown as Record<string, SizePreset>;
export function resolvePreset(system: string, gender = "women"): string {
  if (sizePresets[system]) return system;
  const legacy: Record<string, string> = { EU_NUM: "eu", EU: "eu", US: "us", UK: "uk", CN: "cn" };
  const candidate = legacy[system] ? `${gender}_${legacy[system]}` : "";
  if (sizePresets[candidate]) return candidate;

  return "";
}
export function storedSizes(raw: string): string[] {
  try { const value: unknown = JSON.parse(raw); return Array.isArray(value) ? value.filter((x): x is string => typeof x === "string") : []; }
  catch { return []; }
}

export function presetLabel(key: string, lang: string): string {
  if (key === "one_size") return formLabel(key, lang);
  const [gender, group, region] = key.split("_");
  return [formLabel(gender, lang), group === "bottoms" ? formLabel("bottoms", lang) : "", (region || group || "").toUpperCase()].filter(Boolean).join(" · ");
}
// Same population rules as SpecFlow; values are centimetres in the shared presets.
export function presetMeasurements(key: string, size: string): Record<string, string> {
  const values = sizePresets[key]?.sizes[size] ?? {};
  const fields = ["front_length", "back_length", "shoulder", "chest", "waist", "hip", "hem", "sleeve_length", "sleeve_width", "cuff", "collar_width", "waist_height", "front_rise", "back_rise"];
  const aliases: Record<string, string> = { front_length: "pants_length", chest: "bust", sleeve_width: "slvc", cuff: "slvh" };
  return Object.fromEntries(fields.flatMap((field, i) => {
    const value = values[field] ?? values[aliases[field]];
    return value == null ? [] : [[String.fromCharCode(65 + i) + "_" + field, String(value)]];
  }));
}
